import { Component, ReactNode } from 'react';
import './style.scss';

interface IProps {
  className?: string;
  children?: ReactNode;
}

export default class ModalBackground extends Component<IProps, {}> {
  render() {
    return <div className={`custom-modal__background ${this.props.className || ''}`}>{this.props.children}</div>;
  }
}
